import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Business Cards',
	url: '/business_cards',
	icon: 'map',
}];

export default class Business_Card extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		let {match, history, baseUrl, reloadShell, user, main_role} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/business_cards/${match.params.id}`,
				icon: 'map-marker',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Objects.BusinessCard
					id={match.params.id}
					history={history}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
					user={user}
					noDelete={false}
					isAdmin={main_role <= 15}
					canSeeStatus={main_role === UserRoles.Admin}
				/>

			</div>
		)
	}
};